export default __webpack_public_path__ + "static/media/pattern.26179457.ai";